import { render, staticRenderFns } from "./projectAssess.vue?vue&type=template&id=1a8a7e64&scoped=true"
import script from "./projectAssess.vue?vue&type=script&lang=js"
export * from "./projectAssess.vue?vue&type=script&lang=js"
import style0 from "./project.scss?vue&type=style&index=0&id=1a8a7e64&prod&lang=scss&scoped=true&external"
import style1 from "./projectAssess.vue?vue&type=style&index=1&id=1a8a7e64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8a7e64",
  null
  
)

export default component.exports